import type { SupportedLanguage } from "../i18n";
import { FlagDeIcon } from "./icons/FlagDeIcon";
import { FlagEnIcon } from "./icons/FlagEnIcon";
import { FlagEsIcon } from "./icons/FlagEsIcon";
import { FlagFrIcon } from "./icons/FlagFrIcon";
import { FlagItIcon } from "./icons/FlagItIcon";
import { FlagUsIcon } from "./icons/FlagUsIcon";

export const languageOptions: Array<{
  value: SupportedLanguage;
  Flag: typeof FlagEnIcon;
  labelKey:
    | "profile.english"
    | "profile.usEnglish"
    | "profile.german"
    | "profile.italian"
    | "profile.french"
    | "profile.spanish";
}> = [
  { value: "en-UK", Flag: FlagEnIcon, labelKey: "profile.english" },
  { value: "en-US", Flag: FlagUsIcon, labelKey: "profile.usEnglish" },
  { value: "de", Flag: FlagDeIcon, labelKey: "profile.german" },
  { value: "it", Flag: FlagItIcon, labelKey: "profile.italian" },
  { value: "fr", Flag: FlagFrIcon, labelKey: "profile.french" },
  { value: "es", Flag: FlagEsIcon, labelKey: "profile.spanish" },
];
